import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { EmailService } from '../../_services/email.service';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../_services/google-analytics.service';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-contact-us-form',
    templateUrl: './contact-us-form.component.html',
    styleUrls: ['./contact-us-form.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatError, NgxSpinnerComponent, AsyncPipe]
})
export class ContactUsFormComponent implements OnInit, OnDestroy {
  private readonly formBuilder = inject(UntypedFormBuilder);
  private readonly emailService = inject(EmailService);
  private readonly reCaptchaV3Service = inject(ReCaptchaV3Service);
  private readonly spinnerService = inject(NgxSpinnerService);
  private readonly router = inject(Router);
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);

  public contactUsForm: UntypedFormGroup;
  public email = new UntypedFormControl('', [Validators.required, Validators.email]);
  public message = new UntypedFormControl('', [Validators.required]);
  public spinner$!: Observable<NgxSpinner>;
  public isSubmitting = false;

  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    this.contactUsForm = this.formBuilder.group({
      email: this.email,
      message: this.message
    });
  }

  public ngOnInit(): void {
    this.spinner$ = this.spinnerService.spinnerObservable;
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

  public getErrorMessage(): string {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  public async submit(): Promise<void> {
    if (this.contactUsForm.valid) {
      this.googleAnalyticsService.eventEmitter('Contact Us Form Submitted', 'Footer', 'Submitted Contact Us Form', 'Contact Us Form', 1);
      await this.spinnerService.show();
      this.isSubmitting = true;
      this.reCaptchaV3Service.execute('newsletterSignup')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(token => {
        this.emailService.sendInquiryEmail(this.message.value, this.email.value, `https://mypoolhut.com${this.router.url}`, token)
          .pipe(take(1))
          .subscribe(async res => {
            if (res) {
              this.emailService.success('Thank you for your inquiry. We will reach out to you soon.')
            } else {
              console.error('Failed to submit email inquiry.');
            }
            this.isSubmitting = false;
            await this.spinnerService.hide();
          },
          async error => {
            this.isSubmitting = false;
            console.error('Failed to submit email inquiry.', error);
            this.emailService.error('Failed to submit. Please try again.');
            await this.spinnerService.hide();
          });
      });
    }
  }

}
